module.exports = __webpack_public_path__ + "img/option-mail.f225d190.png";